// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"572":"polySeg","694":"compute"}[chunkId] || chunkId) + "." + {"427":"54481846","453":"abd36b29","572":"09a2f407","694":"1ebeac67","714":"a6838ddd","769":"3e5877df","853":"09268148","856":"60e6e1c6"}[chunkId] + ".chunk.js";
};